module.exports = __webpack_public_path__ + "static/img/1093.e963429.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1093.jpg
// module id = 275
// module chunks = 0